import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { DataProvider } from './context/DataContext';
import { AppRoutes } from './routes/AppRoutes';
import { GlobalStyles } from './styles/GlobalStyles';
import InstallPrompt from './components/common/InstallPrompt';
import UpdateBanner from './components/common/UpdateBanner';

function App() {
  return (
    <BrowserRouter>
      <UpdateBanner />
      <GlobalStyles />
      <AuthProvider>
        <DataProvider>
          <AppRoutes />
        </DataProvider>
        <InstallPrompt />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
